import { createFileRoute } from '@tanstack/react-router';

import { InspectionPreparationListPage } from '@/features/nis2/pages/InspectionPreparationListPage';

export const Route = createFileRoute('/_authenticated/nis2/reports/audit-preparation')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <InspectionPreparationListPage />
      </div>
    </div>
  );
}
